import JsonSchemaUriError from "./JsonSchemaUriError.mjs";
class EvaluationJsonSchemaUriError extends JsonSchemaUriError {}
export default EvaluationJsonSchemaUriError;